module.exports = __webpack_public_path__ + "img/bth_yaobu_nor.68f2fc95.png";